
// components/popup/VictimPopup.tsx
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { PersonSearchPopup } from "./PersonSearchPopup";
import {
  fetchVicitmConditions,
  fetchVictimTypes,
} from "services/assetRecoveryService";
import { Person } from "types";

interface VictimPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  onInputChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => void;
  onSearchPerson: (e: React.FormEvent) => void;
  onPersonSelect: (personId: string) => void;
  onUserSubmit: (data: any, isEditMode: boolean) => void;
  formData: any;
  loading: boolean;
  error: string | null;
  searchFayda: string;
  setSearchFayda: (value: string) => void;
  searchPhone: string;
  setSearchPhone: (value: string) => void;
  searchedPersons: any[];
  selectedPerson: any;
  selectedPersonId: string;
  searchLoading: boolean;
  userFormLoading: boolean;
  isEditMode?: boolean;
  existingData?: any;
      setSelectedPerson?: Dispatch<SetStateAction<Person | null>>;
        setSelectedPersonId?: Dispatch<SetStateAction<string>>;
        setSearchedPersons?: Dispatch<SetStateAction<Person[]>>;
}

export const VictimPopup: React.FC<VictimPopupProps> = (props) => {
  const [victimConditions, setVictimConditions] = useState<
    { id: string; name: string }[]
  >([]);
  const [victimTypes, setVictimTypes] = useState<
    { id: string; name: string }[]
  >([]);
  
  useEffect(() => {
    fetchVicitmConditions().then(setVictimConditions).catch(console.error);
    fetchVictimTypes().then(setVictimTypes).catch(console.error);
  }, []);

  return (
    <PersonSearchPopup
      {...props}
      title={props.isEditMode ? "Edit Victim" : "Add Victim"}
      description={props.isEditMode ? "Edit victim information" : "Add victim information"}
      isEditMode={props.isEditMode}
      existingData={props.existingData}
         setSearchedPersons={props.setSearchedPersons}
      setSelectedPerson={props.setSelectedPerson}
      setSelectedPersonId={props.setSelectedPersonId}
    >
      <div className="flex flex-col">
        <label className="referral-popup-label">Victim Name</label>
        <input
          type="text"
          className="referral-form-field"
          onChange={props.onInputChange}
          name="victim_name"
          placeholder="Victim Name"
          value={props.formData.victim_name || ""}
        />
      </div>
      <div className="flex flex-col mt-4">
        <label className="referral-popup-label">Victim Type</label>
        <select
          className="referral-form-field"
          onChange={props.onInputChange}
          name="victim_type"
          value={props.formData.victim_type || ""}
        >
          <option value="" disabled>
            Select Type
          </option>
          {victimTypes?.map((types) => (
            <option key={types.id} value={types.id}>
              {types.name}
            </option>
          ))}
        </select>
      </div>
      <div className="flex flex-col mt-4">
        <label className="referral-popup-label">Victim Department</label>
        <input
          type="text"
          className="referral-form-field"
          onChange={props.onInputChange}
          name="victim_department"
          placeholder="Victim Department"
          value={props.formData.victim_department || ""}
        />
      </div>
      <div className="flex flex-col mt-4">
        <label className="referral-popup-label">Victim Condition</label>
        <select
          className="referral-form-field"
          onChange={props.onInputChange}
          name="victim_condition"
          value={props.formData.victim_condition || ""}
        >
          <option value="" disabled>
            Select Condition
          </option>
          {victimConditions?.map((condition) => (
            <option key={condition.id} value={condition.id}>
              {condition.name}
            </option>
          ))}
        </select>
      </div>
    </PersonSearchPopup>
  );
};